module.exports = __webpack_public_path__ + "static/img/page05.12b9008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page05.jpg
// module id = 3QN5
// module chunks = 0